import React from 'react';
import { ScheduleClinicianManagement } from '../ScheduleClinicianManagement';
import {
  envUrlClinicianManagment,
  ACCESS_TOKEN_COOKIE,
  ID_TOKEN_COOKIE,
  envUrl,
  routes,
} from '../../config';
import cookieService from '../../services/cookieService';
import providerService from '../../services/providerService';
import useClinicOperationHandlers from '../../hooks/useClinicOperationHandlers';

const TeamMembers = () => {
  const accessToken = cookieService.getCookie(ACCESS_TOKEN_COOKIE);
  const idToken = cookieService.getCookie(ID_TOKEN_COOKIE);
  const { providerId } = providerService.getProviderDetails();
  const logoutUrl = `${envUrl}${routes.dpx.logout}`;
  const remoteModulePath = 'clinicianManagement/ClinicianApp';
  const operationHandlers = useClinicOperationHandlers();

  const clinicManagementConfig = {
    enabled: true,
    scheduleCMScriptPath: `${envUrlClinicianManagment}/static/chunks/remoteEntry.js`,
    remoteModulePath,
  };

  return (
    <>
      <ScheduleClinicianManagement
        config={clinicManagementConfig}
        rcRemoteModuleKey={1}
        accessToken={accessToken}
        idToken={idToken}
        selectedProviderId={providerId}
        pageType="team-members"
        logoutUrl={logoutUrl}
        operationHandlers={operationHandlers}
      />
    </>
  );
};

export default TeamMembers;
